import Styled from 'styled-components'

export const Container = Styled.footer`
  width: 100%;
  background-color: var(--background-app);
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 30px;
`

export const AttendanceSection = Styled.div`
  background-color: var(--primary-color);
  padding: 25px 20px;
  border-radius: 4px;
  margin-bottom: 40px;
  max-width: 100%;
  
`

export const AttendanceTitle = Styled.h3`
  color: var(--button-primary-text);
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 25px;
  margin-top: 0;
  line-height: 1.3;
  font-family: var(--font-family-base);
  text-transform: uppercase;
  letter-spacing: 0.3px;
`

export const ContactsContainer = Styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0;
  flex-wrap: nowrap;
  
  @media(max-width: 768px) {
    flex-wrap: nowrap;
    gap: 0;
    align-items: center;
  }
`

export const ContactBox = Styled.div`
  text-align: center;
  flex: 1;
  padding: 0 20px;
  min-width: 0;
  
  p {
    color: var(--button-primary-text);
    font-size: 12px;
    font-weight: 600;
    margin: 0;
    line-height: 1.4;
    font-family: var(--font-family-base);
    text-transform: uppercase;
    letter-spacing: 0.3px;
    white-space: nowrap;
  }
  
  @media(max-width: 480px) {
    padding: 0 10px;
    flex: 1;
    
    p {
      font-size: 12px;
      white-space: normal;
      }
  }
`

export const Divider = Styled.div`
  width: 1px;
  height: 60px;
  background-color: var(--button-primary-text);
  margin: 0 10px;
  opacity: 0.6;
  display: block;
  
  @media(max-width: 480px) {
    height: 40px;
    margin: 0 5px;
  }
`

export const PaymentSection = Styled.div`
  text-align: center;
  max-width: 100%;
  margin-bottom: 0;
`

export const PaymentTitle = Styled.h4`
  color: var(--title-color);
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
  margin-top: 0;
  font-family: var(--font-family-base);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  position: relative;
  padding-bottom: 15px;
  
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 50px;
    height: 1px;
    background-color: var(--title-color);
  }
  
  @media(max-width: 480px) {
    font-size: 14px;
  }
`

export const PaymentSubtitle = Styled.p`
  color: var(--text-color);
  font-size: 14px;
  font-weight: 600;
  margin-top: 15px;
  margin-bottom: 25px;
  font-family: var(--font-family-base);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  
  @media(max-width: 480px) {
    font-size: 14px;
  }
`

export const LogosContainer = Styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 60px;
  flex-wrap: wrap;
  margin-bottom: 62px;
  
  @media(max-width: 768px) {
    gap: 40px;
  }
  
  @media(max-width: 480px) {
    gap: 30px;
  }
`

export const LogoWrapper = Styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  min-width: 60px;
  
  img {
    height: ${props => props.isMastercard ? '48px' : '24px'};
    width: auto;
    max-width: 100%;
    object-fit: contain;
  }
  
  @media(max-width: 768px) {
    min-width: 50px;
    
    img {
      height: ${props => props.isMastercard ? '36px' : '20px'};
    }
  }
`


export const HelpSection = Styled.div`
  background-color: #F5F5F7;
  border-radius: 8px;
  padding: 48px 20px 10px 20px;
`

export const HelpTitle = Styled.h3`
  color: var(--title-color);
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 8px 0;
  font-family: var(--font-family-base);
`

export const HelpList = Styled.div`
  display: flex;
  flex-direction: column;
`

export const HelpItem = Styled.button`
  display: flex;
  align-items: center;
  gap: 32px;
  width: 100%;
  background: none;
  border: none;
  padding: 32px 0;
  cursor: pointer;
  text-align: left;
  border-bottom: 1px solid #E0E0E0;
  font-family: var(--font-family-base);

  &:last-child {
    border-bottom: none;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }

  .help-item-icon {
    flex-shrink: 0;
  }

  .help-item-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .help-item-label {
    color: var(--text-color);
    font-size: 14px;
    font-weight: 500;
  }

  .help-item-subtitle {
    color: #9DA1A6;
    font-size: 12px;
    font-weight: 400;
  }

  .help-item-chevron {
    flex-shrink: 0;
    color: #9DA1A6;
  }
`
